import HeaderNone from './../../components/component/header/header_none.jsx';

import SupportComponent from './../../components/component/support_components/support.jsx';


import FooterNone from './../../components/component/footer/footer_none.jsx'
import LaptopFooter from './../../components/component/footer/laptop_footer.jsx';



function Support() {
    return (
            <main>
                <HeaderNone />
                <SupportComponent />

                <FooterNone />
                <LaptopFooter />

            </main>
    );
}

export default Support;

